import React from 'react'

function Bags() {
  return (
    <div>Bags</div>
  )
}

export default Bags